import { ClearOutlined, SearchOutlined,  } from '@ant-design/icons'
import { Button, Card, Checkbox, Input, Select, Space } from 'antd'
import React from 'react'

export const OrganizerSearch = (props) => {

  return (
    <Card className='search_card my_custom_search_card'
     title={props.title}
     actions={[
        <Button onClick={props.onSearchSubmit}><SearchOutlined key="filter" />Filtriraj</Button>,
        <Button onClick={(e) => props.onClearFilters(e)}><ClearOutlined key="clearFilter"/>Očisti filtere</Button>
     ]}
    >
      <Space align='start'>
        <Input 
            id="orgName"
            addonBefore={"Organizator"} 
            onChange={(e) => props.userInputHandler(e)}
            value={props.searchModel["orgName"]}/>

        <Input 
            id="oib"
            addonBefore={"OIB"}
            onChange={(e) => props.userInputHandler(e)}
            value={props.searchModel["oib"]}/>
        
        <Checkbox id="orgType" onChange={(e) => props.userInputHandler(e)} checked={props.searchModel["orgType"] === 2}>Pripadnik međunarodne mreže</Checkbox>
        <Checkbox id="sts" onChange={(e) => props.userInputHandler(e)} checked={props.searchModel["sts"] === 1}>Status</Checkbox>
      </Space>
    </Card>
  )
}

OrganizerSearch.defaultProps = {
    title: "Pretraga"
}
